import ApiService from '../ApiService';

const DEFAULT_PERIOD = 'week';

export const getTodayDate = () => new Date().toISOString().slice(0, 10);

export const createDefaultAnalyticsFilters = () => ({
  fromDate: getTodayDate(),
  toDate: getTodayDate(),
  period: DEFAULT_PERIOD,
  handlerId: '',
});

const buildAnalyticsParams = ({ fromDate, toDate, period, handlerId }) => {
  const params = {
    from_date: fromDate,
    to_date: toDate,
    period: period || DEFAULT_PERIOD,
  };

  if (handlerId) {
    params.handler_id = handlerId;
  }

  return params;
};

export const fetchInstagramHandlers = () => ApiService.get('creatorhandler', { Type: 2 });
export const fetchAllAccounts = () => ApiService.get('all_accounts');

export const fetchInstagramAccountAnalytics = (filters) =>
  ApiService.get('instagram_account_analytics', buildAnalyticsParams(filters));

export const fetchInstagramMediaAnalytics = (filters) =>
  ApiService.get('instagram_media_analytics', buildAnalyticsParams(filters));

export const resolveAnalyticsRows = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.results)) return payload.data.results;
  if (payload?.id || payload?.date || payload?.thumbnail_url || payload?.media_url) return [payload];
  if (payload?.data?.id || payload?.data?.date || payload?.data?.thumbnail_url || payload?.data?.media_url) {
    return [payload.data];
  }
  return [];
};

export const resolveAnalyticsPayload = (response) => response?.data?.data ?? response?.data ?? {};

export const resolveInstagramHandlerId = (response) => {
  const handlerRows = resolveAnalyticsRows(resolveAnalyticsPayload(response));
  const activeHandler = handlerRows.find(
    (item) => item?.id || item?.handler_id || item?.handlerunique_id
  );

  return activeHandler?.id || activeHandler?.handler_id || activeHandler?.handlerunique_id || '';
};

export const resolveConnectedState = (response, expectedAccountType) => {
  const rows = resolveAnalyticsRows(resolveAnalyticsPayload(response));
  const rootConnected = response?.data?.is_connected;

  if (typeof rootConnected === 'boolean') {
    return rootConnected;
  }

  return rows.some((item) => {
    const connectionStatus = item?.is_connected ?? item?.is_connect;
    const accountType = item?.AccountType || item?.accountType;
    if (typeof connectionStatus !== 'boolean') {
      return false;
    }

    return accountType === expectedAccountType && connectionStatus;
  });
};

export const resolveConnectedAccountType = (response) => {
  const rows = resolveAnalyticsRows(resolveAnalyticsPayload(response));
  const connectedRow = rows.find((item) => {
    const connectionStatus = item?.is_connected ?? item?.is_connect;
    return connectionStatus === true;
  });

  return connectedRow?.AccountType || connectedRow?.accountType || '';
};
